<template>
  <div class="side_r_block d_flex flex_direction_col align_item_c">

    <div>
      <div class="side_i_title bc_F2F2F2 fz16 c_1A1A1A text_center">相关推荐</div>
      <div class="rec_w">

        <div v-for="item in recommendList" :key="item.projectNo" class="rec_i" @click="onRecommendClick(item)">

          <div class="rec_picture_w">
            <el-image
              class="rec_img"
              :src="item.cover
                ? item.cover + '!220'
                : require('@/assets/images/QaKkPnoKQkBK7pdG.jpeg')"
              alt=""
              lazy
            >
              <div slot="placeholder">
                <div class="rec_picture_placeholder" :style="randomRgb()" />
              </div>
            </el-image>

          </div>
          <span class="rec_title fz14 c_1A1A1A text_ellipsis">{{ item.title }}</span>
          <div class="rec_price fz14 c_CF3342 font_w_bold">
            当前价￥{{ numTurnText(item.currentPrice) }}元{{ item.priceUnitDesc ? '/' + item.priceUnitDesc : '' }}
          </div>

        </div>

        <div v-if="!recommendList || !recommendList.length" style="margin: 50px 0;" class="x_y_center">
          <img src="@/assets/images/empty_icon.png" alt="">
          <span style="margin:0 0 0 10px" class="fz14">暂无数据</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { auction_recommend } from '@/api/portal'
import { numTurnText } from '@/utils'

export default {
  inject:['reload'],
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      recommendList: []

    }
  },
  computed: {
    queryParams() {
      const { projectNo } = this.$route.query
      return {
        projectNo,
        tradeKind: this.itemDetail?.project.tradeKind,
        rows: 10
      }
    },
    numTurnText() {
      return function(val) {
        return numTurnText(val)
      }
    },
    randomRgb() {
      return function() {
        return {
          backgroundColor:
          'rgb(' +
          Math.floor(Math.random() * 130 + 110) +
          ',' +
          Math.floor(Math.random() * 130 + 110) +
          ',' +
          Math.floor(Math.random() * 130 + 110) +
          ')'
        }
      }
    }
  },
  watch:{
    'itemDetail.project.tradeKind':{
      handler(n){
        if(n){
          this.getRecommendList()
        }
      },
      immediate:true
    }
  },
  created() {
  },

  methods: {
    // 获取项目推荐 api
    async getRecommendList() {
      const { data } = await auction_recommend(this.queryParams)
      this.recommendList = data
    },
    // 项目推荐跳转
    onRecommendClick(item){
      this.$router.push({
        name:'tradeDetail',
        query:{
          projectNo: item.projectNo
        }
      })
      this.reload()
    },
  }
}
</script>

<style lang="scss" scoped>
.side_r_block{
  width: 262px;
  margin: 0 0 10px 10px ;
  .scan_icon{
    vertical-align: text-bottom;
    margin: 0 10px 0 0;
  }
  .scan_w{
    margin: 0 0 10px 0;
  }
  .scan_c{
    padding: 25px 0;
    border: 1px solid #E6E6E6;
    border-top: none;
  }
  .side_i_title{
    width: 262px;
    height: 46px;
    line-height: 46px;
    border: 1px solid #E6E6E6;
  }
  .rec_w{
    border: 1px solid #E6E6E6;
    padding: 20px;
    border-top: none;
  }
  .rec_picture_placeholder{
    width: 220px;
    height: 150px;
  }
  .rec_title{
    display: inline-block;
    width: 220px;
    margin: 10px 0;
  }
  .rec_i{
    margin: 0 0 20px 0;
    // border: 2px solid transparent;
    &:hover{
      // border-color: rgba($color: #0983cc, $alpha: .5);
      // box-shadow: 0 0 0px 1px #0983cc;
      .rec_title{
        text-decoration: underline;
      }
      cursor: pointer;
    }
  }
  .more_code{
    width: 200px;
    height: 200px;
    margin: 0 0 10px 0;
  }
  .rec_img{
    width: 220px;
    height: 150px;
    border: 1px solid #e6e6e6;
    ::v-deep img{
      position: static;   // 兼容ie
      display: block;
      width: 100%;
      height: 100%;
      transform: none;  // 兼容ie
    }
  }
}
</style>
